var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState, useRef, useEffect } from 'react';
import t from 'prop-types';
import { Precarga } from '../index';
import ContenidoVentana from './contenido-ventana'; // import { MarcoAmpliacion } from '../index'

import useOnResize from '../util/use-onresize';

function ContenidoTipoIframe(_ref) {
  var src = _ref.src,
      titulo = _ref.titulo,
      style = _ref.style,
      children = _ref.children;

  var _useState = useState(true),
      loadingSrc = _useState[0],
      setLoadingSrc = _useState[1];

  var _useState2 = useState({
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  }),
      ebodyRect = _useState2[0],
      setEbodyRect = _useState2[1];

  var _useState3 = useState(1),
      timeoutTime = _useState3[0],
      setTimeoutTime = _useState3[1];

  var iframeRef = useRef();
  var ebodyRef = useRef();
  useOnResize(ebodyRef, function (rect) {
    setEbodyRect(rect);
    setTimeoutTime(1);
  });
  useEffect(function () {
    if (!ebodyRef.current) {
      return;
    }

    if (timeoutTime > 65000) {
      return;
    }

    function esIgualQueEbodyRect(r) {
      return r && ebodyRect.left === r.left && ebodyRect.top === r.top && ebodyRect.width === r.width && ebodyRect.height === r.height;
    }

    var timeoutId = window.setTimeout(function () {
      var rect = ebodyRef.current.getBoundingClientRect();

      if (!esIgualQueEbodyRect(rect)) {
        setEbodyRect(rect);
        setTimeoutTime(1);
      } else {
        setTimeoutTime(timeoutTime * 2);
      }
    }, timeoutTime);
    return function () {
      return window.clearTimeout(timeoutId);
    };
  }, [ebodyRect.left, ebodyRect.top, ebodyRect.width, ebodyRect.height, timeoutTime]);

  function handleLoad(e) {
    var document = iframeRef.current.contentDocument || iframeRef.current.ownerDocument;

    if (!document) {
      window.console.error('contenido-tipo-iframe handleLoad', {
        iframe: iframeRef.current
      });
      return;
    }

    var ebody = document.getElementById('ebody');

    if (ebody) {
      ebodyRef.current = ebody;
      setEbodyRect(ebody.getBoundingClientRect());
    }

    setLoadingSrc(false);
  }

  var iframeStyle = _extends({
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    border: 'none',
    boxSizing: 'border-box',
    verticalAlign: 'bottom',
    opacity: loadingSrc ? 0 : 1
  }, style);

  var left = ebodyRect.left,
      top = ebodyRect.top,
      width = ebodyRect.width,
      height = ebodyRect.height;
  var childrenStyle = {
    position: "absolute",
    pointerEvents: "none",
    left: left,
    top: top,
    width: width,
    height: height
  };
  return React.createElement(ContenidoVentana, null, loadingSrc && React.createElement(Precarga, null), React.createElement('iframe', {
    ref: iframeRef,
    src: src,
    style: iframeStyle,
    title: titulo,
    onLoad: handleLoad,
    allowFullScreen: true
  }), !loadingSrc && React.createElement('div', {
    className: 'transparencia',
    style: childrenStyle
  }, children));
}

ContenidoTipoIframe.propTypes = process.env.NODE_ENV !== "production" ? {
  src: t.string,
  titulo: t.string,
  style: t.object,
  children: t.any // const MAX_REINTENTOS = 20
  // class ContenidoTipoIframe_class extends Component {
  //     static propTypes = {
  //         src: t.string,
  //         titulo: t.string,
  //         style: t.object,
  //         imagenUsuarioVisible: t.bool
  //     }
  //     constructor (props) {
  //         super(props);
  //         this.state = {
  //             loading: true,
  //             reintentosCargaEbody: 0,
  //             ebody: {
  //                 x: 0,
  //                 y: 0,
  //                 left: 0,
  //                 top: 0,
  //                 width: 0,
  //                 height: 0
  //             }
  //         }
  //         this.iframeRef = React.createRef()
  //     }
  //     handleResize = () => {
  //         this.setState({ loading: false }, () => {
  // //            window.setTimeout( () => {
  //                 const iframe = this.iframeRef.current
  //                 const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
  //                 // iframeDocument podria ser null si se ha cerrado la ventana antes de cargar el ejercicio,
  //                 if (!iframeDocument) { 
  //                     return 
  //                 }
  //                 const ebody = iframeDocument.getElementById('ebody')
  //                 if (ebody) {
  //                     const ebodyRect = ebody.getBoundingClientRect()
  //                     this.setState( {
  //                         ebody: ebodyRect
  //                     })
  //                 } else if (this.state.reintentosCargaEbody < MAX_REINTENTOS) {
  //                     this.setState(
  //                         prevState => ({ reintentosCargaEbody: prevState.reintentosCargaEbody + 1 }), 
  //                         this.handleResize()
  //                     )
  //                 } else {
  //                     window.console.error("Número de reintentos agotados detectando ebody")
  //                 }            
  // //            }, 100)    
  //         })
  //     }
  //     componentDidMount() {
  //         this.setState(
  //             { reintentosCargaEbody: 0 },
  //             () => {
  //                 const contentWindow = this.iframeRef.current.contentWindow
  //                 if (contentWindow) {
  //                     contentWindow.addEventListener('resize', this.handleResize, false)
  //                 }
  //             }
  //         )    
  //     }
  //     componentDidUpdate( prevProps ) {
  //         if (prevProps.src !== this.props.src) {
  //             this.setState({loading: true })
  //         }
  //     }
  //     componentWillUnmount() {
  //         const contentWindow = this.iframeRef.current.contentWindow
  //         if (contentWindow) {
  //             contentWindow.removeEventListener('resize', this.handleResize, false)
  //         }
  //     }
  //     render () {
  //         const { src, style, titulo, imagenUsuarioVisible } = this.props
  //         const { loading } = this.state
  //         const iframeStyle = { 
  //             position: "absolute",
  //             left: 0, top: 0, right: 0, bottom: 0,
  //             border: 'none', 
  //             boxSizing: 'border-box', 
  //             // overflow: 'hidden', 
  //             verticalAlign: 'bottom',
  //             opacity: loading ? 0 : 1,
  //             ...style
  //         }
  //         const ebody = this.state.ebody
  //         const pizarraStyle = {
  //             left: ebody.left || 0,
  //             top: ebody.top || 0,
  //             width: ebody.width || "100%",
  //             height: ebody.height || "100%"
  //         }
  //         return (
  //             <ContenidoVentana>
  //                 { loading && <Precarga /> }
  //                 <iframe 
  //                     ref={this.iframeRef} 
  //                     src={ src } 
  //                     style={ iframeStyle } 
  //                     title={ titulo } 
  //                     onLoad={this.handleResize}  
  //                 />
  //                 { !loading && <Pizarra visible={imagenUsuarioVisible} resolucion={{w: 1024, h: 700}} style={pizarraStyle} /> }
  //             </ContenidoVentana>
  //         )
  //     }
  // }

} : {};
export default ContenidoTipoIframe;